
import { defineComponent } from "vue";
import Modal from "../Components/Modal.vue";
import gameApplication from "../../game/game-app";

export default defineComponent({
  name: "WaitForOpponentModal",

  data() {
    return {
      elapsedTime: 30,
      timer: undefined, 
    };
  },

  mounted() {
    this.startTimer();
  },

  methods: {
    startTimer(): void {
      const timeLimit = 30;
      let startTime = Date.now();
      let elapsedTime = startTime;
      this.timer = setInterval(() => this.modalTimer(elapsedTime, startTime, timeLimit), 1000); // this should be a 1 second interval 
    },

    modalTimer(elapsedTime: number, startTime: number, timeLimit: number): void {
      elapsedTime = Date.now() - startTime;
      let seconds = Math.round((elapsedTime / 1000));
      this.elapsedTime = timeLimit - seconds;

      if (this.elapsedTime == 0) {
        clearInterval(this.timer);
      }
    },

    onCancel(): void {
      clearInterval(this.timer);
      this.$emit('close');
      gameApplication.sendAcceptGame(false);
      gameApplication.initRoom(); // stop the confirmation modal from being displayed
    },
  },

  components: { Modal },
});
